"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var EditProductOptionsItem_1 = __importDefault(require("./EditProductOptionsItem"));
var close_icon_svg_1 = __importDefault(require("res/img/close-icon.svg"));
var SelectWithNewEntry_1 = __importDefault(require("components/common/inputs/SelectWithNewEntry"));
var AddButton_1 = __importDefault(require("components/common/buttons/AddButton"));
var EditProductOptionsGroup = function (_a) {
    var productOption = _a.productOption, otherGroups = _a.otherGroups, storeOptionItems = _a.storeOptionItems, onRemoveOption = _a.onRemoveOption, onAddItem = _a.onAddItem, onRemoveItem = _a.onRemoveItem, onChangeItem = _a.onChangeItem, onSubmitItem = _a.onSubmitItem;
    var _b = react_1.useState(false), open = _b[0], setOpen = _b[1];
    var toggleOpen = function () {
        setOpen(!open);
    };
    var changeHandler = function (item) {
        setOpen(false);
        onAddItem(item);
    };
    var submitHandler = function (value) {
        setOpen(false);
        onSubmitItem(value);
    };
    var getSelectData = function () {
        return storeOptionItems.map(function (storeOption) {
            for (var _i = 0, _a = productOption.productOptionItems; _i < _a.length; _i++) {
                var dataOption = _a[_i];
                if (dataOption.id === storeOption.id) {
                    return __assign(__assign({}, storeOption), { live: false });
                }
            }
            return storeOption;
        });
    };
    return (react_1.default.createElement("div", { className: 'edit-product-options-group' },
        react_1.default.createElement("div", { className: 'edit-product-options-group__top flex flex-row flex-space-between' },
            react_1.default.createElement("span", { className: 'title' },
                productOption.name,
                "s"),
            react_1.default.createElement("button", { type: 'button', "aria-label": 'Remove Option Group', className: 'remove-button flex flex-column flex-center', onClick: function () { return onRemoveOption(productOption); }, title: 'Remove' },
                react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Remove' }))),
        react_1.default.createElement("div", { className: 'edit-product-options-group__items' }, productOption.productOptionItems.map(function (optionItem) { return (react_1.default.createElement(EditProductOptionsItem_1.default, { key: optionItem.id, productOptionItem: optionItem, optionGroup: productOption, otherGroups: otherGroups, onRemoveItem: onRemoveItem, onChange: onChangeItem })); })),
        !open &&
            react_1.default.createElement(AddButton_1.default, { label: "Add " + productOption.name.toLowerCase() + " option", onClick: toggleOpen }),
        open &&
            react_1.default.createElement("div", { className: 'edit-product__add-form form' },
                react_1.default.createElement("div", { className: 'edit-product__add-form__top flex flex-row flex-space-between' },
                    react_1.default.createElement("span", { className: 'title' },
                        "Add a ",
                        productOption.name.toLowerCase(),
                        " option"),
                    react_1.default.createElement("button", { type: 'button', title: 'Close', "aria-label": 'close', className: 'edit-product__add-form__close flex flex-column flex-center', onClick: toggleOpen },
                        react_1.default.createElement("img", { src: close_icon_svg_1.default, alt: 'Close' }))),
                react_1.default.createElement(SelectWithNewEntry_1.default, { value: null, label: productOption.name + " option", data: getSelectData(), onChange: changeHandler, onSubmit: submitHandler }))));
};
exports.default = EditProductOptionsGroup;
